import Marquee from "react-fast-marquee";

const items = [
  "Custom Apparel",
  "DTF Printing",
  "Spirit Wear",
  "Bachelorette Tees",
  "Centreville, VA",
  "Bulk Orders",
  "Family Reunions",
  "Team Drops",
];

export const MarqueeBand = () => {
  return (
    <section
      data-testid="marquee-band"
      className="relative border-y border-white/10 bg-[#FF2222] py-5 md:py-7 overflow-hidden"
    >
      <Marquee gradient={false} speed={55} pauseOnHover={false}>
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="font-display uppercase text-3xl md:text-5xl text-white tracking-tight mx-8 flex items-center gap-8"
          >
            {t}
            <span className="inline-block w-3 h-3 bg-black rotate-45" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
